import { Text } from "@ecco/ui/text";
import { Button } from "@ecco/ui/button";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { Tooltip } from "@ecco/ui/tooltip";
import { useTooltip } from "@ecco/ui/use-tooltip";
import { useRef } from "react";
import { styles } from "./Bar.styles";
import { useGetHeaders } from "@hooks/useGetHeaders";
import { TryAndBuy } from "@lib/constants/contentful/try-and-buy";
import { Progress } from "@ecco/ui/progress";
import { CommonCMS } from "@lib/constants/contentful";

type Props = {
    onClick: () => void;
    isNotAvailable: boolean;
    isLoading: boolean;
};

export const Bar = ({ onClick, isNotAvailable, isLoading }: Props) => {
    const tooltipRef = useRef(undefined);
    const { isTooltipOpen, setIsTooltipOpen } = useTooltip({ tooltipRef });

    const { tooltip, wantToReseve, label, notAvailable } = useGetHeaders({
        source: CommonCMS.page,
        microcopiesWithTitles: {
            wantToReseve: TryAndBuy.bar.wantToReserve,
            tooltip: TryAndBuy.bar.tooltip,
            label: TryAndBuy.label,
            notAvailable: TryAndBuy.notAvailable,
        },
    });

    const onClickTooltip = () => setIsTooltipOpen(!isTooltipOpen);

    return (
        <Flex {...styles.container}>
            <Flex {...styles.innerWrapper}>
                {isLoading ? (
                    <Progress {...styles.progress} variant="black" isIndeterminate />
                ) : (
                    <>
                        <Text>{isNotAvailable ? notAvailable : wantToReseve}</Text>
                        <Tooltip
                            isOpen={isTooltipOpen}
                            hasArrow={false}
                            label={tooltip}
                            closeOnScroll={true}
                            aria-label={tooltip}
                            {...styles.tooltip}
                        >
                            <ECCOIcon
                                ref={tooltipRef}
                                name="info"
                                onClick={onClickTooltip}
                                sx={styles.tooltipIcon}
                            />
                        </Tooltip>
                    </>
                )}
            </Flex>
            <Button
                isLoading={isLoading}
                isDisabled={isNotAvailable}
                onClick={onClick}
                {...styles.button}
                variant="ghost"
            >
                {/* Wrapped so React removes this element rather than a bare text node. Chrome's
                    Google Translate replaces text nodes with its own <font> nodes and leaves the
                    originals detached, so removing one throws NotFoundError and crashes the PDP. */}
                <span>{label}</span>
            </Button>
        </Flex>
    );
};
